export default "__VITE_ASSET__c2550186__"